import { Injectable } from '@angular/core';

import { User, UserAut } from "../interfaces/user-interfaces";
import { ReplaySubject } from 'rxjs';
import { userAutVacio, userVacio } from '../datos/user-data';
import { LogService } from "./log-servicios";

@Injectable({
    providedIn: 'root'
})
export class DataUserService {
    constructor(
        private logService: LogService,
    ) { }

    //user y userAut para los que necesitan un dato normal, componentes que se cargan cuando el dato está definido 
    //y no va a cambiar durante toda su vida
    //user$ y userAut$ para los que necesitan un Observable, como componentes que están mostrados y de pronto cambia el valor,
    //por ejemplo en nav.component.ts se cargaba userAut una sola vez (no autorizado, mostraba cantidad 0) y no se actualizaba.
    //1: creo un ReplaySubject (ej userAut_) (cuando usé Subject funcionó bien la primera vez pero al navegar se perdía la cantidad)
    //2: creo y exporto un Observable que apunta al Subject (ej userAut$)
    //3: cuando hay un cambio (en los updates) actualizo el observable ( ej userAut_.next(userAut))
    //4: en los componentes que lo necesiten, me suscribo al observable y actualizo una propiedad normal como this.userAut (ej:
    //          userAutSub = userAut$.subscribe(u => {
    //              this.userAut = u;
    //          });)
    //Si se usa suscripción no hace falta Async en el HTML
    //En los updates actualizo tanto el normal como el observable
    user: User = userVacio;
    user_ = new ReplaySubject<User>(1);
    user$ = this.user_.asObservable();
    userUpdate(usr: User) {
        this.user = usr;
        this.user_.next(usr);
    }

    superUser: boolean = false;
    superUser_ = new ReplaySubject<boolean>(1);
    superUser$ = this.superUser_.asObservable();
    superUserUpdate(su: boolean) {
        this.superUser = su;
        this.superUser_.next(su);
    }


    userAut: UserAut = userAutVacio;
    userAut_ = new ReplaySubject<UserAut>(1);
    userAut$ = this.userAut_.asObservable();
    userAutUpdate(userAut: UserAut) {
        this.userAut = userAut;
        this.userAut_.next(userAut);
    }

    //userYaCargado no tiene un subject ni un observable porque su grabación es instantánea
    userYaCargado: boolean = false;   //true: muestra artículos
    userYaCargadoUpdate(VF: boolean): void {
        this.userYaCargado = VF;
    }

    //user elegido en una consulta de usuarios
    userElegido: User = userVacio;
    userElegido_ = new ReplaySubject<User>(1);
    userElegido$ = this.userElegido_.asObservable();
    userElegidoUpdate(usrElegido: User) {
        this.userElegido = usrElegido;
        this.userElegido_.next(usrElegido);
    }

    //lista de usuarios que el usr actual puede ver. Para tipo "Usuario", solo él mismo. Para "Admin", todos
    //esta lista se lee una sola vez, al ingresar, y se mantiene por toda la sesión.
    users: User[];
    users_ = new ReplaySubject<User[]>(1);
    users$ = this.users_.asObservable();
    usersUpdate(usrs: User[]) {
        this.users = usrs;
        this.users_.next(usrs);
    }

    //filtros de consulta de usuarios, quiero que se mantengan mientras usr navega a otras pantallas
    filtroUsrNombre: string = '*';
    filtroUsrCedula: string = '*';
    filtroUsrMail: string = '*';
    filtrosUsrUpdate(filCli: string, filCed: string, filMail: string) {
        this.filtroUsrNombre = filCli;
        this.filtroUsrCedula = filCed;
        this.filtroUsrMail = filMail;
    }

    //lista de userAuts
    userAuts: UserAut[];
    userAuts_ = new ReplaySubject<UserAut[]>(1);
    userAuts$ = this.userAuts_.asObservable();
    userAutsUpdate(uas: UserAut[]) {
        this.userAuts = uas;
        this.userAuts_.next(uas);
    }

    //filtros de consultas de activación de usuarios y empresas, se mantienen mientras usr navega a otras pantallas
    filtroActivAutorizado: string = '*';
    filtroActivRuc: string = '*';
    filtroActivMail: string = '*';
    filtrosActivUpdate(filAut: string, filRuc: string, filMail: string) {
        this.filtroActivAutorizado = filAut;
        this.filtroActivRuc = filRuc;
        this.filtroActivMail = filMail;
    }

}
